<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="miter" aria-hidden="true">
    <polygon points="12,3 21,6 21,12 12,21 3,12 3,6"/>
    <polyline points="8,12 11,15 16,9"/>
  </svg>
</template>
